<template>
  <div
    v-if="showLoader"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-sm"
  >
    <!-- Loader circular simple como Vuetify -->
    <div class="relative">
      <!-- Círculo giratorio usando el color primary del tema -->
      <div class="h-16 w-16 rounded-full border-4 border-gray-200 border-t-[var(--theme-primary)] animate-spin" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useLoaderStore } from '@/store/loaderStore.js'

export default {
  name: 'TheLoader',
  computed: {
    ...mapState(useLoaderStore, ['showLoader']),
  },
}
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
